import $ from 'jquery';

window.addEventListener('load', function() {

  var testimonials_list = document.querySelector('.js-testimonials-list');

  if(!testimonials_list)
    return;

  window.paged = 1;
  var lang = $('html').attr('lang');
  var maxnumpages = document.querySelector('.js-list-temoignage-item') ? 
    document.querySelector('.js-list-temoignage-item').dataset.maxnumpages : 0;
  var select = document.querySelector('#select_departement');
  var loadMoreButton = document.querySelector('.js-load-more-testimonials');
  var departmentSlug = lang == 'fr-FR' ? 'departement' : 'department';
  var currentRequest = null;

  // On filter change, empty List & load a new List
  select.addEventListener('change', function(){
    testimonials_list.classList.add('loading');
    testimonials_list.innerHTML = '';
    window.paged = 1;
    loadMoreButton.classList.add('visually-hidden');
    rewriteUrl();
    loadTestimonials();
  });

  // On Load More Click, Show n+1 Page and Load hidden n+2 Page
  loadMoreButton.addEventListener('click', function(){

    // Disabled during ajax load
    if(loadMoreButton.classList.contains('disabled'))
      return;

    window.paged++;
    loadTestimonials();
  });

  // Show previous Page & Load hidden next Page with filters
  function loadTestimonials(){

    // Disable loadMoreButton during ajax load
    loadMoreButton.classList.add('disabled');
    
    // Abort potential previous request
    if(currentRequest != null)
      currentRequest.abort();
    
    // Ajax Post
    currentRequest = $.ajax({
      cache: true,
      url: ajaxurl,
      type: 'get',
      data: {
        action: 'load_temoignages',
        paged: window.paged,
        departement: select.value,
      },
      success: function(html) {

        if(html){
          
          // Add page results to list
          testimonials_list.innerHTML += html;

          // On 1st page, set maxnumpage
          if(window.paged == 1)
            maxnumpages = document.querySelector('.js-list-temoignage-item') ? 
              document.querySelector('.js-list-temoignage-item').dataset.maxnumpages : 0;

          if(window.paged >= maxnumpages)
            loadMoreButton.classList.add('visually-hidden');
          else
            loadMoreButton.classList.remove('visually-hidden');

        }

        // Enable loadMoreButton after ajax load
        loadMoreButton.classList.remove('disabled');
        testimonials_list.classList.remove('loading');
      }
    });
  }

  // Rewrite current page URL according to current filters
  function rewriteUrl() {
    var parameter = location.protocol + '//' + location.host + location.pathname;
    if (select.value) {
      parameter += '?' + departmentSlug + '=' + select.value;
    }
    window.history.pushState("", "", parameter);
  }
  
});
